import React, { useState, useContext, useEffect } from 'react';
import Check_Icon from 'styles/staticAssets/images/Check_Icon.svg';
import ImageComponent from 'atoms/Image';
import { getCurrentLocation, getFullImagePath, isEmptyObject } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import PRODUCT_CONSTANTS from '../Constants/ProductListingModalOptionsConstants';
import { UpsizeSeelectAnalytics } from 'organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { useLocation } from 'react-router-dom';

const checkIfExistsInCart = (cardId, getCartModifiers) => {
  if (isEmptyObject(getCartModifiers)) {
    let modExists = getCartModifiers.filter(({ id }) => id === cardId);
    return modExists.length > 0 ? true : false;
  } else {
    return false;
  }
};

const setDefaultFlagCheck = (updatedItems, userOrderState, id, isDefault, getCartModifiers) => {
  const { SETFLAGCASE } = PRODUCT_CONSTANTS;
  const { FROMFLAGEDIT } = START_ORDER_CONSTANTS;
  if (updatedItems.length === 0) {
    if (isDefault && userOrderState.minipdpData.fromFlag !== FROMFLAGEDIT) {
      return SETFLAGCASE.DEFAULT;
    } else if (userOrderState.minipdpData.fromFlag === FROMFLAGEDIT && checkIfExistsInCart(id, getCartModifiers)) {
      return SETFLAGCASE.FROMEDIT;
    }
  } else if (updatedItems?.includes(id)) {
    return SETFLAGCASE.ITEMINCLUDES;
  }
};

const getClassName = (cardType, selectedProduct) => {
  return `${cardType === 'carousal' ? 'carousal-modifier-item-card' : 'modifier-item-card'} ${
    selectedProduct ? 'selected' : ''
  }`;
};
const getSourceClassName = cardType => {
  return cardType === 'carousal' ? 'carousal-modifier-product-save' : 'modifier-product-save';
};
const getImageClassName = cardType => {
  return cardType === 'carousal' ? 'carousal-modifier-card-image' : 'modifier-card-image';
};
const upsizeSelectedAnalytics = ({ analyticsObject, currLocation }, selectedProduct) => {
  if (!selectedProduct) {
    UpsizeSeelectAnalytics(analyticsObject, currLocation);
  }
};
const ModifierCard = props => {
  const {
    cardData,
    min,
    max,
    savedModifierHandler,
    savedModifiers,
    cardType,
    tenantReducer,
    modgrpId,
    modGrpName,
    updatedItems,
    getCartModifiers,
  } = props;

  const { id, name, size, dname, isDefault, imageName, isHidden, calorificInfo } = cardData;

  let dName = dname && dname.length && dname[0].value;

  const [selectedProduct, setSelectedProduct] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    pdpScreenCommons: { modGroupIdsUpdated },
  } = userOrderState;
  const { MODGROUP_IDS_UPDATE, UPDATE_DEFAULT_MODGROUP } = MENU_PDP_PAGE_CONSTANTS;
  const { CONFIRM_UPSIZE_ANALYTICS } = START_ORDER_CONSTANTS;
  const { SETFLAGCASE } = PRODUCT_CONSTANTS;
  const location = useLocation();

  useEffect(() => {
    let setSelectedFlag = setDefaultFlagCheck(updatedItems, userOrderState, id, isDefault, getCartModifiers);
    switch (setSelectedFlag) {
      case SETFLAGCASE.DEFAULT:
      case SETFLAGCASE.FROMEDIT:
        setSelectedProduct(true);
        savedModifierHandler(cardData, true, savedModifiers);
        break;
      case SETFLAGCASE.ITEMINCLUDES:
        setSelectedProduct(true);
        break;
      default:
        setSelectedProduct(false);
        break;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, updatedItems, isDefault, getCartModifiers]);

  const onSaveProduct = () => {
    if (!isDefault && !modGroupIdsUpdated.includes(modgrpId)) {
      userOrderStateDispatch({ type: MODGROUP_IDS_UPDATE, value: modgrpId });
    } else if (isDefault) {
      let filteredArr = modGroupIdsUpdated.filter(item => item !== modgrpId);
      userOrderStateDispatch({ type: UPDATE_DEFAULT_MODGROUP, value: filteredArr });
    }
    let analyticsObject = { name, size };
    let currLocation = getCurrentLocation(location.pathname);
    let analyticspayload = { analyticsObject, currLocation };
    if (min === 1 && max === 1) {
      upsizeSelectedAnalytics(analyticspayload, selectedProduct);
      !selectedProduct && setSelectedProduct(true);

      savedModifierHandler(cardData, 'single', savedModifiers);
    } else if (selectedProduct && savedModifiers.length > min && savedModifiers.length <= max) {
      setSelectedProduct(false);
      savedModifierHandler(cardData, false, savedModifiers);
    } else if (!selectedProduct && savedModifiers.length >= min && savedModifiers.length < max) {
      upsizeSelectedAnalytics(analyticspayload, selectedProduct);
      setSelectedProduct(true);
      savedModifierHandler(cardData, true, savedModifiers);
    }
    userOrderStateDispatch({
      type: CONFIRM_UPSIZE_ANALYTICS,
      value: { confirmUpsizeName: modGrpName },
    });
  };

  return (
    !isHidden && (
      <div className={getClassName(cardType, selectedProduct)} data-testid='click-save-product' onClick={onSaveProduct}>
        <ImageComponent
          defaultPath={getFullImagePath(null, tenantReducer, true)}
          srcFile={getFullImagePath(imageName, tenantReducer)}
          className={getImageClassName(cardType)}
        />
        <picture>
          <source
            media='(max-width: 1023px)'
            srcSet={selectedProduct ? Check_Icon : null}
            alt={''}
            className={getSourceClassName(cardType)}
          />
          <img src={selectedProduct ? Check_Icon : null} alt={''} className={getSourceClassName(cardType)} />
        </picture>
        <div className='modifier-card-content'>
          <div className='title'>{dName}</div>
          {calorificInfo && <div className='caloricInfo'>{calorificInfo}</div>}
        </div>
      </div>
    )
  );
};

export default ModifierCard;
